import React, { useState, useRef, useCallback } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

// Campo de busca com debounce: só o comportamento (ícone, limpar, atraso no
// onSearch) sobre o TextField padrão do MUI. O visual fica com quem usa, via
// `sx`/`slotProps` (ex.: SearchField, o campo do TopBar).
const DebouncedSearchInput = ({ onSearch, placeholder, delay = 400, slotProps, ...textFieldProps }) => {
  const [inputValue, setInputValue] = useState('');
  const timerRef = useRef(null);

  const handleChange = useCallback((event) => {
    const value = event.target.value;
    setInputValue(value);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      onSearch(value.trim() || '');
    }, delay);
  }, [onSearch, delay]);

  const handleClear = useCallback(() => {
    setInputValue('');
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    onSearch('');
  }, [onSearch]);

  return (
    <TextField
      fullWidth
      placeholder={placeholder}
      value={inputValue}
      onChange={handleChange}
      size="small"
      {...textFieldProps}
      slotProps={{
        ...slotProps,
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: inputValue && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClear} edge="end">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
          ...slotProps?.input,
        },
      }}
    />
  );
};

export default DebouncedSearchInput;
